@if (patientService.data) {
  <ncp-patient />
} @else if (!isLoggingIn) {
  <ng-container
    [ngComponentOutlet]="LoginComponent"
    #outlet="ngComponentOutlet"
  />
} @else {
  <div
    class="loader d-flex flex-row justify-content-center"
  >
    <p-progress-spinner ariaLabel="loading" />
  </div>
}
